import { render, staticRenderFns } from "./InformationAd.vue?vue&type=template&id=60c5302a&scoped=true"
import script from "./InformationAd.vue?vue&type=script&lang=js"
export * from "./InformationAd.vue?vue&type=script&lang=js"
import style0 from "./InformationAd.vue?vue&type=style&index=0&id=60c5302a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c5302a",
  null
  
)

export default component.exports